import React from 'react';
import { Box } from '@mui/material';
import DailyBlock from '../components/authentification/DailyBlock';
import VideoBlock from '../components/authentification/VideoBlock';


const Authentification = () => {

    return (
        <Box
            sx={{
                minHeight: '100vh',
                minWidth: '100vw',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                px: { xs: 2, sm: 0 },

            }}
        >
            <Box
                sx={{
                    height: '90vmin',
                    // width: '80vmax',
                    width: { xs: '100%', sm: '80vmax' }, // Change la largeur pour les petits écrans
                    flexDirection: { xs: 'column', sm: 'row' }, // Aligne les éléments en colonne sur mobile et en ligne sur grand écran
                    display: 'flex',

                }}>
                <DailyBlock />
                <VideoBlock />
            </Box>
        </Box >
    );
};
export default Authentification;

